module.exports = __webpack_public_path__ + "media/12_33.dc85d0b1.wav";